import React, { useState } from "react";
import { Box, Button } from "@material-ui/core";
import AppointmentCreateForm from "../AppointmentCreateForm";
import { useSelector } from "react-redux";

const Appointment = () => {
  // const [step, setStep] = useState(1);
  // const { user } = useSelector((store) => store);

  // const setDisplayName = () => {
  //   let name;
  //   if (user.user.displayName) name = user.user.displayName;
  //   return name;
  // };

  return (
    <section className="wpo-contact-pg-section section-padding">
      <div className="container">
        {/* <div className="row admin-form"> */}
          <div className="col col-lg-10 offset-lg-1">
            <div className="wpo-contact-title">
              <h2>Programare Aromaterapie</h2>
            </div>
            <div className="wpo-contact-form-area ">
              <AppointmentCreateForm />
              {/* name={setDisplayName()} */}
            </div>
          </div>
        {/* </div> */}
      </div>
    </section>
  );
};

export default Appointment;
